/**
 * Echobot Notification Container
 * Listens to toastService and displays Echobot notifications
 */

import React, { useState, useEffect } from 'react';
import { toastService, ToastType } from '../../services/toastService';
import EchobotNotification from './EchobotNotification';

const EchobotNotificationContainer: React.FC = () => {
  const [notifications, setNotifications] = useState<Array<{
    id: string;
    type: ToastType;
    message: string;
    duration: number;
  }>>([]);

  useEffect(() => {
    const unsubscribe = toastService.subscribeEchobot(setNotifications);
    return unsubscribe;
  }, []);

  return (
    <>
      {notifications.map((notification) => (
        <EchobotNotification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          duration={notification.duration}
          onClose={() => toastService.removeEchobot(notification.id)}
        />
      ))}
    </>
  );
};

export default EchobotNotificationContainer;

